import api from '@/services/api';

export const autoOffersApi = {
  list(params = {}) {
    return api.get('/auto-offers', { params });
  },
  get(id) {
    return api.get(`/auto-offers/${id}`);
  },
  create(payload) {
    return api.post('/auto-offers', payload);
  },
  update(id, payload) {
    return api.put(`/auto-offers/${id}`, payload);
  },
  pause(id) {
    return api.post(`/auto-offers/${id}/pause`);
  },
  start(id) {
    return api.post(`/auto-offers/${id}/start`);
  },
  remove(id) {
    return api.delete(`/auto-offers/${id}`);
  }
};

export default autoOffersApi;
